// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.providers-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.providers-section .providers-wrap {
  --logo-box-border-radius: 1rem;
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.providers-section .providers-wrap .logo-img-box {
  background-color: var(--white-1000);
  border-radius: var(--logo-box-border-radius);
  aspect-ratio: 20/10;
  display: flex;
  justify-content: center;
  align-items: center;
}
.providers-section .providers-wrap .logo-img-box img {
  width: 70%;
  height: 70%;
  object-fit: contain;
  object-position: center;
}
.providers-section .providers-wrap .embla {
  width: 100%;
  filter: drop-shadow(0px 4px 4px var(--black-150));
  -webkit-filter: drop-shadow(0px 4px 4px var(--black-150));
}
.providers-section .providers-wrap .embla .embla__viewport {
  border-radius: var(--logo-box-border-radius);
  overflow: hidden;
}
.providers-section .providers-wrap .embla .embla__viewport .embla__container {
  display: flex;
}
.providers-section .providers-wrap .embla .embla__viewport .embla__container .embla__slide {
  min-width: 0;
  flex: 0 0 25%;
  padding: 0 1rem;
}
@media screen and (max-width: 991.98px) {
  .providers-section {
    padding: 2.5rem 0;
  }
  .providers-section .providers-wrap .embla .embla__viewport .embla__container .embla__slide {
    padding: 0 0.5rem;
  }
}
@media screen and (max-width: 767.98px) {
  .providers-section {
    padding: 2rem 0;
  }
  .providers-section .providers-wrap {
    --logo-box-border-radius: 0.5rem;
  }
  .providers-section .providers-wrap .embla .embla__viewport .embla__container .embla__slide {
    padding: 0 0.25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ProvidersSection/ProvidersStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,8BAAA;EACA,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AACI;EACE,mCAAA;EACA,4CAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACN;AACM;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;AACR;AAGI;EACE,WAAA;EACA,iDAAA;EACA,yDAAA;AADN;AAGM;EACE,4CAAA;EACA,gBAAA;AADR;AAGQ;EACE,aAAA;AADV;AAGU;EACE,YAAA;EACA,aAAA;EACA,eAAA;AADZ;AAQE;EAhDF;IAiDI,iBAAA;EALF;EAWU;IACE,iBAAA;EATZ;AACF;AAgBE;EAhEF;IAiEI,eAAA;EAbF;EAeE;IACE,gCAAA;EAbJ;EAkBU;IACE,kBAAA;EAhBZ;AACF","sourcesContent":[".providers-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .providers-wrap {\n    --logo-box-border-radius: 1rem;\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .logo-img-box {\n      background-color: var(--white-1000);\n      border-radius: var(--logo-box-border-radius);\n      aspect-ratio: 20/10;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      img {\n        width: 70%;\n        height: 70%;\n        object-fit: contain;\n        object-position: center;\n      }\n    }\n\n    .embla {\n      width: 100%;\n      filter: drop-shadow(0px 4px 4px var(--black-150));\n      -webkit-filter: drop-shadow(0px 4px 4px var(--black-150));\n\n      .embla__viewport {\n        border-radius: var(--logo-box-border-radius);\n        overflow: hidden;\n\n        .embla__container {\n          display: flex;\n\n          .embla__slide {\n            min-width: 0;\n            flex: 0 0 calc(100% / 4);\n            padding: 0 1rem;\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n\n    .providers-wrap {\n      .embla {\n        .embla__viewport {\n          .embla__container {\n            .embla__slide {\n              padding: 0 0.5rem;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n\n    .providers-wrap {\n      --logo-box-border-radius: 0.5rem;   \n    \n      .embla {\n        .embla__viewport {\n          .embla__container {\n            .embla__slide {\n              padding: 0 0.25rem;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
